import { COUNTRY_CODE_TO_COUNTRY_NAME } from 'modules/country/constants/code'

/**
 * Gets the country name from its code.
 * @param  {string} code
 * @returns {string}
 */
function getCountryFromCodeCountryUtil (code) {
  return COUNTRY_CODE_TO_COUNTRY_NAME[code]
}

export {
  getCountryFromCodeCountryUtil
}
